import { Component, Input } from '@angular/core'
import { CurrentProductService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { EbProduct } from '../../features/product/interfaces/eb-product.interface'

@Component({
    selector: 'eb-successor',
    templateUrl: './eb-successor.component.html',
    styleUrls: ['./eb-successor.component.scss'],
    standalone: false
})
export class EbSuccessorComponent {
  @Input() orderable = false

  constructor(protected currentProductService: CurrentProductService) {}

  successor$: Observable<EbProduct> = this.currentProductService.getProduct().pipe(
    map((product: EbProduct) => {
      return product.successor
    })
  )

  successorImage$ = this.successor$.pipe(
    map((product: EbProduct) => (product?.images ? product?.images[0] : {}))
  )
}
